export default __webpack_public_path__ + "static/media/staketext.cffbb42f.svg";